/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'string',
      enum: [
        'YES_IN_LINE_W_LEGAL_REQS',
        'YES_NOT_LEGALLY_REQUIRED_VOLUNTARILY',
        'NO_NOT_LEGALLY_REQUIRED',
        'NO_OUT_OF_LINE_W_LEGAL_REQS',
      ],
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    the_fac_paid_an_annual_bonus: valueSchema,
  },
}
